import { render, staticRenderFns } from "./MedicalInsuranceList.vue?vue&type=template&id=0beead2e&scoped=true&lang=pug"
import script from "./MedicalInsuranceList.vue?vue&type=script&lang=js"
export * from "./MedicalInsuranceList.vue?vue&type=script&lang=js"
import style0 from "./MedicalInsuranceList.vue?vue&type=style&index=0&id=0beead2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beead2e",
  null
  
)

export default component.exports